import { get } from 'lodash/fp';
import request from 'utils/request_ajax';
import { TYPES, routes as ROUTES } from '../../constants/config';
import { PATH_BUILDER } from '../../constants/actionTypes';

export const EDIT_AND_VIEW_ACTIVITY = 'edit_and_view_activity';
export const EDIT_ONLY = 'edit_only';

const { OWNERSHIP } = PATH_BUILDER;
const actions = {
  create: ownership => ({ type: OWNERSHIP.CREATE, ownership }),
  remove: ownership => ({ type: OWNERSHIP.REMOVE, id: ownership.id }),
  update: ownership => ({ type: OWNERSHIP.UPDATE, ownership }),
};

const api = {
  create: data => request.postJSON(ROUTES.OWNERSHIPS, data),
  delete: ownership => request.delete(ROUTES.OWNERSHIP(ownership.id)),
  update: (ownership, data) =>
    request.put(ROUTES.OWNERSHIP(ownership.id), data),
};

export function createOwnership(user) {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const path = getState().pathBuilder;
      api
        .create({
          ownableId: path.id,
          ownableType: TYPES.PATH,
          ownerId: user.id,
        })
        .then(ownership => {
          dispatch(actions.create(ownership));
        });
    });
}

export function removeOwnership(ownership) {
  return (dispatch, getState) =>
    new Promise(resolve => {
      const currentUserId = get('meta.currentUser.id')(getState());
      api.delete(ownership).then(() => {
        dispatch(actions.remove(ownership));
        if (ownership.owner.id === currentUserId) {
          window.location.href = ROUTES.CONTENT.INDEX;
        }
      });
    });
}

export function updateOwnership(ownership, changes = {}) {
  return dispatch =>
    new Promise(resolve => {
      api.update(ownership, changes).then(({ success, ...response }) => {
        if (success) {
          dispatch(actions.update({ ...ownership, ...response }));
        }
      });
    });
}

export function togglePermission(ownership) {
  return dispatch =>
    dispatch(
      updateOwnership(ownership, {
        permission:
          ownership.permission === EDIT_ONLY
            ? EDIT_AND_VIEW_ACTIVITY
            : EDIT_ONLY,
      }),
    );
}
